<template>
  <img ref="image" />
</template>

<script>
export default {
  name: 'VImage',
  props: {
    src: {
      type: [String],
      required: true,
    },
    error: {
      type: [String],
      required: false,
      // transparent pixel png
      default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    },
  },
  data() {
    return {
      imageHasErrored: false,
      timeout: null,
    };
  },
  mounted() {
    this.getImage();
  },
  destroyed() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  methods: {
    getImage(elem = null) {
      const img = new Image();
      const element = elem || this.$refs.image;

      if (this.imageHasErrored) {
        img.src = this.getNonCachingSrcRequest();
      } else {
        img.src = this.src;
      }

      img.onload = () => {
        element.src = img.src;
        this.$emit('loaded');
      };
      img.onerror = () => {
        this.imageHasErrored = true;
        element.src = this.error;
        this.$emit('errored');
        if (this.src) {
          this.checkImageEverySecond(element);
        }
      };
    },
    checkImageEverySecond(element) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.getImage(element);
      }, 1000);
    },
    getNonCachingSrcRequest() {
      return `${this.src}?${Date.now()}`;
    },
  },
  watch: {
    src() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.getImage();
    },
  },
};
</script>
